/**
 * A step stack is stack of steps that are navigated in a sequence, and can be ditched to go back to the start.
 */

import { useRouter } from 'next/router';
import { useCallback } from 'react';

import type { Step } from '../types/step';
import type { StepManagerEffectReturnType } from '../types/step_manager';

/**
 * TODO: Review this after signup_rm_adding_modal test is finished.
 *
 * Used for recording the depth of a stack, so that in a later step it's able to ditch the stack and back to the start.
 */
export const STACK_DEPTH_QUERY_PARAM = 'd';

/**
 * The queryParams field for a step that is part of a stack.
 * It increments the stack depth by 1, or sets it to 1 if it's the first step.
 */
export const stackStepQueryParams: Step['queryParams'] = (appData, router) => {
  const depth = Number(router?.query[STACK_DEPTH_QUERY_PARAM]);
  return {
    [STACK_DEPTH_QUERY_PARAM]: isNaN(depth) ? '1' : String(depth + 1),
  };
};

/**
 * If it's a step stack, recorded by `STACK_DEPTH_QUERY_PARAM`, ditch the stack and back to the start.
 */
export function useDitchStepStack(goBack: StepManagerEffectReturnType['goBack']): () => void {
  const router = useRouter();
  return useCallback(() => {
    const depth = Number(router.query[STACK_DEPTH_QUERY_PARAM]);
    if (!isNaN(depth)) {
      goBack(depth, true);
    }
  }, [goBack, router.query]);
}
